import React, { useState } from 'react'
import { WindowOpener } from '../../../helpers/window-opener'
import { Boton, Label } from 'asocomponents'
import { WEBURLEGALES } from '../../../helpers/frontend'
import { formatearNumero } from "../../../../modules/utils/formatearNumero.js"

export default function SiniestrosJuicio({ siniestros }) {
    const [message, setMessage] = useState("")


    const sonResponse = (err, res) => {
        if (err) {
            setMessage(res)
        } else {
            setMessage(res)
        }
    }

    return (
        <div>
            <div className="flex flex-row items-center text-xs font-bold w-[350px] mb-2">
                <Label texto="Siniestros asociados:" />
            </div>
            <div className="flex flex-row items-center text-xs font-bold w-[650px]">
                <div className="overflow-hidden flex justify-start">
                    <div className="shadow-md sm:rounded-lg w-[95%] ">
                        <table className="table-fixed text-xs text-left rtl:text-right text-gray-500 w-[100%] ">
                            <thead className="text-[0.6rem] text-gray-700 uppercase bg-gray-200">
                                <tr>
                                    <th scope="col" className="text-center  py-1" style={{ width: "20%" }}>
                                        Nro. Siniestro
                                    </th>
                                    <th scope="col" className="text-center  py-1" style={{ width: "40%" }}>
                                        Descripción
                                    </th>        
                                    <th scope="col" className="text-center  py-1" style={{ width: "15%" }}>
                                        IBM
                                    </th>                                                                   
                                    <th scope="col" className="text-center  py-1" style={{ width: "7%" }}>
                                    </th>
                                    <th scope="col" className="text-center  py-1" style={{ width: "7%" }}>
                                    </th>
                                    <th scope="col" className="text-center  py-1" style={{ width: "7%" }}>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {siniestros &&
                                    siniestros.map((sin, index) => (
                                        <tr
                                            className="bg-white border-b hover:bg-gray-50 text-xs font-normal"
                                            key={sin.idDenuncia}
                                        >
                                            <td className="text-center py-1">{sin.nroSiniestro}</td>
                                            <td className="text-center py-1">{sin.descripcionAccidente}</td>
                                            <td className="text-center py-1">{formatearNumero(sin.ibm)}</td> 
                                            <td className="text-center py-1">
                                                <WindowOpener url={`${WEBURLEGALES}/VisorAntecedentes/${sin.idDenuncia}`} bridge={sonResponse} width={900} height={700}>
                                                    <Boton fondo="rojo" height="h-6" width="w-8" alt="Antecedentes Siniestrales" icono="tareas" />
                                                </WindowOpener>
                                            </td>
                                            <td className="text-center py-1">
                                                <WindowOpener url={`${WEBURLEGALES}/VisorDocDigSiniestro/${sin.nroSiniestro}`} bridge={sonResponse} width={500} height={400}>
                                                    <Boton fondo="rojo" height="h-6" width="w-8" alt="Documentos Digitalizados Siniestro" icono="document" />
                                                </WindowOpener>
                                            </td>
                                            <td className="text-center py-1">
                                                <WindowOpener url={`${WEBURLEGALES}/VisorCartasSiniestros/${sin.idDenuncia}`} bridge={sonResponse} width={800} height={450}>
                                                    <Boton fondo="rojo" height="h-6" width="w-8" alt="Cartas del Siniestro" icono="carta" />
                                                </WindowOpener>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    )
}
